"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Context_1 = require("../../Context");
const style_module_scss_1 = __importDefault(require("./style.module.scss"));
const hooks_1 = require("../../hooks");
;
const Popup = (_a) => {
    var { onBackground, onClose, renderProps } = _a, props = __rest(_a, ["onBackground", "onClose", "renderProps"]);
    const { render, dialogStyle, className, style, children, bottomSheetMaxWidth, popupPreferTop } = props;
    const Styles = (0, hooks_1.useStyle)(style_module_scss_1.default, '_popup-');
    const containerContext = (0, react_1.useContext)(Context_1.ContainerContext);
    const popupRef = (0, react_1.useRef)(null);
    const [position, setPosition] = (0, react_1.useState)({
        x: 0,
        y: 0
    });
    const popupMove = (rect, preferTop = false) => {
        if (!popupRef.current)
            return;
        const popup = popupRef.current;
        const popupWidth = popup.offsetWidth;
        const popupHeight = popup.offsetHeight;
        const margin = 8;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        // Центрирование по горизонтали относительно кнопки
        let x = rect.x + rect.width / 2 - popupWidth / 2;
        x = Math.max(0, Math.min(x, viewportWidth - popupWidth));
        const canShowBelow = rect.y + rect.height + margin + popupHeight <= viewportHeight;
        const canShowAbove = rect.y - popupHeight - margin >= 0;
        let y;
        if (preferTop) {
            y = canShowAbove
                ? rect.y - popupHeight - margin
                : rect.y + rect.height + margin;
        }
        else {
            y = canShowBelow
                ? rect.y + rect.height + margin
                : rect.y - popupHeight - margin;
        }
        y = Math.max(0, Math.min(y, viewportHeight - popupHeight));
        setPosition({ x, y });
    };
    (0, react_1.useEffect)(() => {
        if (!containerContext.initPosition.current)
            return;
        popupMove(containerContext.initPosition.current, popupPreferTop);
    }, [containerContext.initPosition, popupPreferTop]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: Styles('popup-wrapper'), children: [(0, jsx_runtime_1.jsx)("div", { className: Styles('background'), onClick: onBackground }), (0, jsx_runtime_1.jsx)("dialog", { className: Styles('popup-container'), tabIndex: 1, role: "dialog", style: Object.assign(Object.assign({}, dialogStyle), { maxWidth: bottomSheetMaxWidth, transform: `translate(${position.x}px, ${position.y}px)` }), ref: popupRef, open: true, children: typeof render === 'function' ? render(renderProps) :
                    (0, jsx_runtime_1.jsx)("div", { className: Styles('popup') + (className ? ' ' + className : ''), style: style, children: children }) })] }));
};
exports.Popup = Popup;
